/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowRoundSyncForwardIcon16Light } from './ArrowRoundSyncForwardIcon16Light';
import { ArrowRoundSyncForwardIcon16Regular } from './ArrowRoundSyncForwardIcon16Regular';
import { ArrowRoundSyncForwardIcon16Solid } from './ArrowRoundSyncForwardIcon16Solid';
import { ArrowRoundSyncForwardIcon20Light } from './ArrowRoundSyncForwardIcon20Light';
import { ArrowRoundSyncForwardIcon20Regular } from './ArrowRoundSyncForwardIcon20Regular';
import { ArrowRoundSyncForwardIcon20Solid } from './ArrowRoundSyncForwardIcon20Solid';
import { ArrowRoundSyncForwardIcon24Regular } from './ArrowRoundSyncForwardIcon24Regular';
import { ArrowRoundSyncForwardIcon24Solid } from './ArrowRoundSyncForwardIcon24Solid';
import { ArrowRoundSyncForwardIcon32Regular } from './ArrowRoundSyncForwardIcon32Regular';
import { ArrowRoundSyncForwardIcon64Regular } from './ArrowRoundSyncForwardIcon64Regular';
var sizes = {
    16: {
        light: ArrowRoundSyncForwardIcon16Light,
        regular: ArrowRoundSyncForwardIcon16Regular,
        solid: ArrowRoundSyncForwardIcon16Solid,
    },
    20: {
        light: ArrowRoundSyncForwardIcon20Light,
        regular: ArrowRoundSyncForwardIcon20Regular,
        solid: ArrowRoundSyncForwardIcon20Solid,
    },
    24: {
        regular: ArrowRoundSyncForwardIcon24Regular,
        solid: ArrowRoundSyncForwardIcon24Solid,
    },
    32: {
        regular: ArrowRoundSyncForwardIcon32Regular,
    },
    64: {
        regular: ArrowRoundSyncForwardIcon64Regular,
    },
};
export var ArrowRoundSyncForwardIcon = forwardRef('ArrowRoundSyncForwardIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
